import { Alert } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { CommonStorageFacilitySerializer } from '@bcba/serializers';
import { VALIDATION_STATUSES } from '@bcba/types';

interface Props {
  facility: CommonStorageFacilitySerializer;
}

export const FacilityStatusAlert = ({ facility }: Props) => {
  const { t } = useTranslation();
  const { status, validationMessage } = facility;

  switch (status) {
    case VALIDATION_STATUSES.PENDING_CHANGE_REQUEST:
      return (
        <Alert
          title={t(`storageFacilities.facilityStatusAlert.${status}.title`)}
          description={validationMessage}
          variant={'error'}
          showCloseButton={false}
        />
      );

    default:
      return null;
  }
};
